import * as React from "react";
import { forwardRef, memo } from "react";
const SvgReply = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M800-200q-17 0-28.5-11.5T760-240v-120q0-50-35-85t-85-35H272l117 117q11 11 11 27t-12 28q-11 11-28 11t-28-11L148-492q-6-6-8.5-13t-2.5-15 2.5-15 8.5-13l185-185q11-11 27-11t28 12q11 11 11 28t-11 28L272-560h368q83 0 141.5 58.5T840-360v120q0 17-11.5 28.5T800-200" })));
const ForwardRef = forwardRef(SvgReply);
const Memo = memo(ForwardRef);
export default Memo;
